const loggingProxy = <T extends object>(
  klazzToWrap: T,
  logMethod: (msg: string) => void
) =>
  new Proxy(klazzToWrap, {
    get(target, property, receiver) {
      const originalMethod: (
        ...args: unknown[]
      ) => // @ts-expect-error Allow for indexing of target
      unknown | Promise<unknown> = target[property];
      const isLogWorthyMethodCall =
        typeof originalMethod === 'function' &&
        property !== 'constructor' &&
        property !== 'name';

      if (isLogWorthyMethodCall) {
        return function (...args: unknown[]) {
          const displayArgs =
            args.length > 0 ? JSON.stringify(args).slice(1, -1) : '';

          const wrappedLog = (result: unknown) => {
            logMethod(
              `${receiver.constructor.name}.${String(
                property
              )}(${displayArgs})${
                result !== undefined ? ` => ${JSON.stringify(result)}` : ''
              }`
            );
          };

          const result = originalMethod.apply(klazzToWrap, args);
          if ((result as Promise<unknown>)?.then) {
            return (result as Promise<unknown>).then((resolved) => {
              wrappedLog(resolved);
              return resolved;
            });
          } else {
            wrappedLog(result);
            return result;
          }
        };
      }
      return originalMethod;
    },
  });

export const supportToolManagerLog = (msg: string) => {
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.log(`[SupportToolManager]: ${msg}`);
  }
};

export default loggingProxy;
